// extracted by css-extract-rspack-plugin
export default {"cell":"CellHeader_cell__biwMi"};